import { render, staticRenderFns } from "./MostrarComprobanteMovimiento.vue?vue&type=template&id=62fe9e04&scoped=true"
import script from "./MostrarComprobanteMovimiento.vue?vue&type=script&lang=js"
export * from "./MostrarComprobanteMovimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fe9e04",
  null
  
)

export default component.exports